// extracted by mini-css-extract-plugin
export var infoRow = "_sh-2";
export var labelContainer = "_sh-0";
export var rightInfo = "_sh-1";